import { Popover } from "antd";
import React, { useContext } from "react";
import { AppContext } from "../../context";

function PopupNotes({ notes }) {
  const info = useContext(AppContext);

  const popoverContent = (
    <div style={{ padding: 10 }}>
      <p>{notes}</p>
    </div>
  );
  return (
    notes && (
      <div className="ahp-reservation-notes">
        <Popover content={popoverContent} title="Notas" trigger="click">
          <a role="button" tabindex="0">
            {info.t("notes")}
          </a>
        </Popover>
      </div>
    )
  );
}

export default PopupNotes;
